import type { ChannelDispatchStatus } from '@/store/ide-v2-slice'

export type CreatorAttentionReason =
  | 'clarification'
  | 'terminology-choice'
  | 'confirmation'
  | null

export interface CreatorAttentionInput {
  dispatchPhase: ChannelDispatchStatus['phase']
  unresolvedIntentPreview: boolean
  pendingConfirmationCount: number
  needsClarification: boolean
}

export function deriveCreatorAttention(
  input: CreatorAttentionInput,
): CreatorAttentionReason {
  if (input.needsClarification) return 'clarification'
  if (input.unresolvedIntentPreview) return 'terminology-choice'
  if (input.pendingConfirmationCount > 0) return 'confirmation'
  return null
}
